import useIsMobile from "../hooks/responsive/use-is-mobile";
import useGetCourses from "../hooks/data/use-get-courses";

import "../assets/scss/astro-ecommerce.scss";
import "../assets/animations/animations.css";
import { useEffect, useRef, useState } from "react";
import axios from "axios";


import Navbar from "../components/navbar";
import PromoSectionLarge from "../components/promo/promoSectionLarge";
import OpenVouchersBanner from "../components/promo/openVouchersBanner";
import CardProduct from "../components/products/cardProduct";
import GroupProduct from "../components/products/groupProduct";
import PackageProduct from "../components/products/packageProduct";
import InfoImage from "../components/store/infoPicture";
import data from "../data/data.json";
import lanidngImage from "../assets/images/hero/shaped_background_landing.svg";
import packageBackgroundImage from "../assets/images/hero/shapes_quienes_somos_background.svg";
import teamBuildingImage1 from "../assets/images/hero/quienes_somos.png";
import teamBuildingImage2 from "../assets/images/hero/team_building_2.jpg";
import teamBuildingImage3 from "../assets/images/hero/team_building_3.jpg";
import aboutUsImage from "../assets/images/hero/home_sobre_nosotros.jpg";
import teamBuildingImage4 from "../assets/images/hero/team_building_4.jpg";
import groupProductImg from "../assets/images/hero/home_talleres_grupales.jpg";
import ourSpace1 from "../assets/images/nuevas/ESPACIO1.jpg"
import ourSpace2 from "../assets/images/nuevas/ESPACIO2.jpg"
import ourSpace3 from "../assets/images/nuevas/ESPACIO3.jpg"
import ourSpace4 from "../assets/images/nuevas/ESPACIO4.jpg"
import { Link } from "react-router-dom";
import InfoPictureForOurSpace from "../components/store/infoPictureForOurSpace";
import heartIcon from "../assets/images/icons/heart.png";
import starIcon from "../assets/images/icons/star.png";
import shieldIcon from "../assets/images/icons/shield.png";
import { FaWhatsapp } from "react-icons/fa";

const packageIcons = {
  "01": heartIcon,
  "02": starIcon,
  "03": shieldIcon,
};



export const Landing = () => {
  const heroImg = "https://muerdete-front-qa.s3.eu-north-1.amazonaws.com/imagenes_web/portada_web.jpg";
  const isMobile = useIsMobile();
  const talleresRef = useRef(null); // Referencia a la sección "talleres"
  const courses = useGetCourses();
  const [popup, setPopup] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const styles = {
    landingBackground: {
      backgroundImage: !isMobile && "url(" + lanidngImage + ")",
      backgroundSize: "cover",
    },
    packageBackground: {
      backgroundImage: !isMobile && "url(" + packageBackgroundImage + ")",
      backgroundSize: "cover",
    },
    section: {
      scrollSnapType: "y mandatory", // Aplicar scroll snap vertical
      height: "fit-content", // Altura para ocupar toda la pantalla
      color: "#ff5a88",
      position: "relative",
    },
    popupOverlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.7)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      padding: isMobile ? "16px" : "32px",
    },
    popupContent: {
      maxWidth: isMobile ? "100%" : "640px",
      maxHeight: isMobile ? "80vh" : "90vh",
      borderRadius: "16px",
      overflow: "hidden",
      boxShadow: "0 24px 60px rgba(0,0,0,0.35)",
      background: "#000",
      cursor: "pointer",
      position: "relative",
    },
    popupImage: {
      width: "100%",
      height: "100%",
      objectFit: "contain",
      display: "block",
    },
    popupClose: {
      position: "absolute",
      top: isMobile ? "8px" : "12px",
      right: isMobile ? "8px" : "12px",
      background: "rgba(0,0,0,0.55)",
      color: "#fff",
      border: "none",
      borderRadius: "999px",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: "16px",
      lineHeight: 1,
      cursor: "pointer",
    },
  };

  useEffect(() => {
    const loadPopup = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_URI}/v1/popups/active`);
        if (res.data?.imageUrl) {
          setPopup(res.data);
          setShowPopup(true);
          document.body.style.overflow = "hidden";
        }
      } catch (err) {
        console.error("No se pudo cargar el popup", err);
      }
    };
    loadPopup();
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
    document.body.style.overflow = "";
  };

  const popupImageSrc = isMobile && popup?.imageUrlMobile ? popup.imageUrlMobile : popup?.imageUrl;

  return (
    <>
      {showPopup && popupImageSrc && (
        <div style={styles.popupOverlay} onClick={handleClosePopup}>
          <div style={styles.popupContent} onClick={handleClosePopup}>
            <button style={styles.popupClose} aria-label="Cerrar" onClick={handleClosePopup}>
              ×
            </button>
            <img src={popupImageSrc} alt="Promoción" style={styles.popupImage} />
          </div>
        </div>
      )}
      <div className="page-container" style={{ position: "relative" }}>
        <Navbar />
        <PromoSectionLarge
          title={"¿Estás listo para morder la vida a bocados?"}
          fullDescription={
            "Únete a la revolución Muerdete. ¡Vamos a cocinar, reír y disfrutar como si no hubiera un mañana!"
          }
          talleresRef={talleresRef}
          firstButtonTitle={"Ya tengo un Bono"}
          secondButtonTitle={"Comprar Bono"}
          pageHeaderMinVh="80vh"
        />

        <div ref={talleresRef} className="position-relative h-100">
          <section style={styles.section}>
            <div className="triangleBackgroundPink"></div>
            <div className="triangleBackgroundPink triangle-pink"></div>
            <div className="col-11 mx-auto my-7" id="talleres">
              <div className="triangle-yellow"></div>
              <div className="mb-5 mx-4 col-lg-6 col-sm-12">
                <h1>Nuestros talleres</h1>
                <p className="lead mb-sm-6 mb-4 text-2xl">
                  En Muerdete, te convertirás en un verdadero rockstar de la cocina. Nuestros talleres son una experiencia culinaria única, llena de diversión y sabores que desafiarán tus sentidos.
                </p>
              </div>
              <OpenVouchersBanner compact />
              <div id='talleres' className="row">
                {courses?.map((course) => (
                  !course.isPrivate && (
                    <div className="col-md-6 col-lg-4 mh-100 mb-4 mb-md-0 px-4" key={course.id}>
                      <CardProduct
                        course={course && course}
                        id={course.id}
                        thumb_src={course.thumbnail?.src}
                        header_src={course.images && course.images[0]}
                        thumb_alt={course.images && course.images[0]}
                        color={course.color}
                        title={course.title}
                        description={course.description}
                        price={course.price}
                        position="center"
                        image={course.images[0]}
                      />
                    </div>
                  )
                ))}

              </div>
            </div>
          </section>
        </div>
        <GroupProduct pageHeaderBgImg={groupProductImg} />
        <section style={styles.section} id="packsTalleres">
          <div className="col-11 col-xl-10 mx-auto py-5">
            <h1 className="text-6xl">Packs de talleres</h1>
            <p className="lead mb-5 text-2xl">
              Consulta nuestros packs para grupos y personalizalos a tu medida.
            </p>
            <div className="row d-flex align-items-stretch">
              {data.packages.map((product) => (
                <PackageProduct
                  key={product.id}
                  thumb_src={packageIcons[product.id] || product.thumb_src}
                  thumb_alt={product.thumb_alt}
                  title={product.title}
                  minimumSpots={product.minimumSpots}
                  price={product.price}
                  pricePerPerson={product.pricePerPerson}
                  idealFor={product.idealFor}
                  featured={product.featured}
                  badgeColor={product.badgeColor}
                  badgeTextColor={product.badgeTextColor}
                  items={product.items}
                />
              ))}
            </div>

            <div className="text-center mt-5">
              <a
                href="https://api.whatsapp.com/send/?phone=%2B34673553301&text=Hola!%20Quiero%20pedir%20un%20presupuesto%20personalizado%20sin%20compromiso"
                target="_blank"
                rel="noopener noreferrer"
                className="d-inline-flex align-items-center justify-content-center text-decoration-none shadow-sm"
                style={{
                  backgroundColor: "rgba(37, 211, 102, 0.12)",
                  border: "1.5px solid #25D366",
                  borderRadius: "50px",
                  padding: "14px 32px",
                  color: "#0f5132",
                  fontWeight: 600,
                  fontSize: isMobile ? "0.95rem" : "1.1rem",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#25D366";
                  e.currentTarget.style.color = "#ffffff";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "rgba(37, 211, 102, 0.12)";
                  e.currentTarget.style.color = "#0f5132";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <FaWhatsapp className="me-2" style={{ fontSize: "1.4rem", color: "currentColor" }} />
                <span>Pídenos tu presupuesto personalizado sin compromiso vía WhatsApp</span>
              </a>
            </div>
          </div>
        </section>
        <section id="teamBuilding" className="container py-5 py-lg-8">
          <InfoImage
            title="Talleres para empresas"
            subtitle={"Team building"}
            paragraphOne={
              "Si estás buscando una forma única y emocionante de fortalecer la cohesión de tu equipo o simplemente quieres disfrutar de un día divertido fuera de la oficina, Muerdete es tu elección ideal. ¡Contáctanos hoy mismo para personalizar tu taller a medida!"
            }
            paragraphTwo={
              "Tus empleados o compañeros de equipo se llevarán recuerdos deliciosos que perdurarán en el tiempo al finalizar la experiencia."
            }
            image1={teamBuildingImage1}
            image2={teamBuildingImage2}
            image3={teamBuildingImage3}
            image4={teamBuildingImage4}
          />
          <Link
            className=
            {
              isMobile
                ? `btn btn-white btn-lg btn-lg text-xl`
                : `btn btn-lg bg-purple text-white text-xl`
            }
            to="/team-building"
          >
            Más información
          </Link>
          <div className="triangle-yellow"></div>
        </section>
        <section id="nuestroEspacio" className="container py-5 py-lg-8">
          <InfoPictureForOurSpace
            title="Nuestro Espacio en el centro de Barcelona"
            paragraphOne={
              "¡Bienvenido a nuestro taller gastronómico! En Muérdete, te abrimos las puertas a la cocina donde tus habilidades culinarias toman vida. 🍴✨"
            }
            image1={ourSpace3}
            image2={ourSpace2}
            image3={ourSpace1}
            image4={ourSpace4}
          />
          <div className="triangle-yellow"></div>
        </section>
        <section style={styles.section} id="sobreNosotros">
          <InfoImage
            title={"Sobre nosotros"}
            paragraphTwo={
              "¡Hola! Somos dos locos amigos apasionados, con más de una década de experiencia en la emocionante escuela de talleres de cocina. En Muerdete, creemos que la cocina es mucho más que preparar alimentos; es una forma de conectar, aprender y disfrutar juntos. Nos encanta la gente, y nuestra misión es simple pero poderosa: hacer que todos disfruten de cada momento que pasan con nosotros. Creemos que la cocina es una puerta a la creatividad y la colaboración, y queremos abrir esa puerta para ti y tu equipo. Lo que nos diferencia es nuestra dedicación a la diversión y el aprendizaje. Nuestros talleres de cocina son mucho más que simples actividades; son experiencias culinarias llenas de desafíos, risas y memorias duraderas. Te retamos a superarte a ti mismo, pero siempre con una sonrisa."
            }
            image1={teamBuildingImage1}
            image2={teamBuildingImage2}
            image3={aboutUsImage}
            image4={teamBuildingImage4}
          />
        </section>
      </div>
    </>
  );
};

export default Landing;
